import React from 'react'
import { HashRouter as Router } from 'react-router-dom'
import './App.scss'
import { CustomProvider } from 'rsuite'
import deDE from 'rsuite/locales/de_DE'
import AppRouter from './router/AppRouter'

// ===================== APP
export default function App() {
	return (
		<CustomProvider locale={deDE}>
			<div id="app">
				<Router>
					<AppRouter />
				</Router>
			</div>
		</CustomProvider>
	)
}
